export default "__VITE_ASSET__CKA0nuUD__"